import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  Alert,
  CircularProgress,
  InputAdornment,
} from '@mui/material';
import {
  Facebook,
  Instagram,
  LinkedIn,
  YouTube,
  GitHub,
  Save,
} from '@mui/icons-material';
import api from '../../services/api';

// Custom icons for platforms not in MUI
const TwitterIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
  </svg>
);

const PinterestIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/>
  </svg>
);

const RedditIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.561-1.249-1.249-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z"/>
  </svg>
);

const SOCIAL_PLATFORMS = [
  { key: 'facebook', label: 'Facebook', icon: Facebook, color: '#1877F2', placeholder: 'https://facebook.com/novosolution' },
  { key: 'instagram', label: 'Instagram', icon: Instagram, color: '#E4405F', placeholder: 'https://instagram.com/novosolution' },
  { key: 'twitter', label: 'X (Twitter)', icon: TwitterIcon, color: '#000000', placeholder: 'https://x.com/novosolution' },
  { key: 'linkedin', label: 'LinkedIn', icon: LinkedIn, color: '#0A66C2', placeholder: 'https://linkedin.com/company/novosolution' },
  { key: 'youtube', label: 'YouTube', icon: YouTube, color: '#FF0000', placeholder: 'https://youtube.com/@novosolution' },
  { key: 'tiktok', label: 'TikTok', icon: TikTokIcon, color: '#000000', placeholder: 'https://tiktok.com/@novosolution' },
  { key: 'pinterest', label: 'Pinterest', icon: PinterestIcon, color: '#BD081C', placeholder: 'https://pinterest.com/novosolution' },
  { key: 'github', label: 'GitHub', icon: GitHub, color: '#181717', placeholder: 'https://github.com/novosolution' },
  { key: 'reddit', label: 'Reddit', icon: RedditIcon, color: '#FF4500', placeholder: 'https://reddit.com/r/novosolution' },
];

const SocialMediaLinksContent = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [links, setLinks] = useState({
    facebook: '', instagram: '', twitter: '', linkedin: '',
    youtube: '', tiktok: '', pinterest: '', github: '', reddit: '',
  });

  useEffect(() => {
    fetchLinks();
  }, []);

  const fetchLinks = async () => {
    try {
      setLoading(true);
      const response = await api.get('/config/social-media-links');
      if (response.data.success && response.data.socialMediaLinks) {
        const { configVersion, lastModified, ...platformLinks } = response.data.socialMediaLinks;
        setLinks(prev => ({ ...prev, ...platformLinks }));
      }
    } catch (err) {
      console.error('Error fetching social media links:', err);
      setError('Failed to load social media links');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      setError('');
      setSuccess('');
      const response = await api.post('/config/social-media-links', {
        socialMediaLinks: links,
        updatedBy: 'admin',
      });
      if (response.data.success) {
        setSuccess('Social media links saved successfully! They will appear in the marketing site footer.');
        setTimeout(() => setSuccess(''), 5000);
      }
    } catch (err) {
      console.error('Error saving social media links:', err);
      setError('Failed to save social media links');
    } finally {
      setSaving(false);
    }
  };

  const updateLink = (platform, value) => {
    setLinks(prev => ({ ...prev, [platform]: value }));
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <Alert severity="info" sx={{ mb: 3 }}>
        Add your social media links below. Only platforms with URLs will appear in the marketing site footer.
      </Alert>
      <Card>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 3 }}>Social Media Profiles</Typography>
          <Grid container spacing={2}>
            {SOCIAL_PLATFORMS.map(({ key, label, icon: Icon, color, placeholder }) => (
              <Grid item xs={12} md={6} key={key}>
                <TextField fullWidth label={label} value={links[key] || ''} onChange={(e) => updateLink(key, e.target.value)} placeholder={placeholder}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Box sx={{ color, display: 'flex', alignItems: 'center' }}>
                          {typeof Icon === 'function' && Icon.prototype ? <Icon /> : <Icon />}
                        </Box>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button variant="contained" startIcon={saving ? <CircularProgress size={20} /> : <Save />} onClick={handleSave} disabled={saving} size="large">
          {saving ? 'Saving...' : 'Save Social Media Links'}
        </Button>
      </Box>
    </Box>
  );
};

export default SocialMediaLinksContent;

